import { render, staticRenderFns } from "./_base-task-drawer.vue?vue&type=template&id=8e653382&"
import script from "./_base-task-drawer.vue?vue&type=script&lang=js&"
export * from "./_base-task-drawer.vue?vue&type=script&lang=js&"
import style0 from "./_base-task-drawer.vue?vue&type=style&index=0&id=8e653382&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports